import { createUseItems } from "../configuration/fetchHooks";
import createConjunctionsFetcher from "../conjunctions/conjunctions";
import { createDetailFetcher } from "../helpers/fetchers";
import { createUseDetail } from "../helpers/hooks";
import { createUseOrbits } from "./fetchHooks";
import createOrbitsFetcher from "./orbits";

// Custom service in charge of handling specific orbits
const orbitDetailFetcher = () => createDetailFetcher("ORBIT");
export const orbitDetail = orbitDetailFetcher();
export const useOrbitDetail = createUseDetail(
  orbitDetail,
  (state) => state.orbitDetail,
);

// Custom service and associated hook in charge of handling the list of orbits
const createOrbits = () => createOrbitsFetcher();
export const orbits = createOrbits();
export const useOrbits = createUseOrbits(orbits, (state) => state.orbits);

export interface Params {
  key: string;
  value: string;
}

export interface OrbitConjunctionsConfig {
  id: number;
  params?: Params[];
}

const orbitConjunctionsUrlComputer = (config: OrbitConjunctionsConfig) => {
  let queryParams = "";
  if (config?.params !== undefined) {
    config.params.forEach((p) => (queryParams += `&${p.key}=${p.value}`));
    queryParams = `?${queryParams.substring(1)}`;
  }
  return `/api/v1/orbits/${config?.id}/conjunctions${queryParams}`;
};

export const orbitConjunctions = createConjunctionsFetcher({
  computeURL: orbitConjunctionsUrlComputer,
  storeId: "ORBIT_CONJUNCTIONS",
});

export const useOrbitConjunctions = createUseItems(
  orbitConjunctions,
  (state) => state.orbitConjunctions,
);
